import styled from "styled-components"
import Div from "../div/div.component"

export const CompanyLogoBarContainer = styled(Div)`
  padding: ${(props) => (props.isNewsletterPage ? "0" : "120px 0")};
  background: ${(props) => (props.hasBackground ? `rgb(${props.bgColor})` : "none")};

  @media screen and (max-width: 931px) {
    padding: ${(props) => (props.hasBackground ? "120px 0" : "60px 0")};
  }
 
  @media screen and (max-width: 780px) {
    padding: ${(props) => (props.isNewsletterPage ? "0" : "60px 0")};
    margin: ${(props) => (props.isNewsletterPage ? "0 0 30px" : "0")};
  }
`

export const MarqueeContainer = styled.div`
  background: ${(props) => (props.hasBackground ? `rgb(${props.bgColor})` : "none")}  ;
  position: relative;


  & .overlay {
    --gradient-color: rgba(${(props) => props.bgColor}, 1),
      rgba(255, 255, 255, 0) !important;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
    bottom: 0;
    background: linear-gradient(to right, rgba(${(props) => props.bgColor}, 1) 0%, rgba(${(props) => props.bgColor}, 0) 100px);
    z-index: 2;
    height: 100%;
    display: block;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    background: linear-gradient(to left, rgba(${(props) => props.bgColor}, 1) 0%, rgba(${(props) => props.bgColor}, 0) 100px);
    z-index: 2;
    height: 100%;
    display: block;
  }
`

export const CompaniesTitleContainer = styled.h2`
  width: fit-content;
  margin: auto;
`

export const CompaniesTitle = styled.h2`
  flex-direction: column;
  grid-column: 3 / span 8;
  text-align: center;
  margin: auto;
  font-size: ${({ theme: { typography }, hasBackground }) =>
    hasBackground ? typography.desktop.h2 : typography.desktop.h5};

  @media screen and (max-width: 999px) {
    grid-column: span 6;
    margin: 0 20px;
  }
    
  @media screen and (max-width: 768px) {
    font-size: ${({ theme: { typography }, hasBackground }) =>
    hasBackground ? typography.mobile.h2 : typography.mobile.h5};
    text-align: left;
    margin-bottom: ${(props) => !props.hasBackground ? "-10px" : "initial"};
  }

  color: ${(props) => props.titleColor};
`

export const CompanyBarImages = styled.div`
  margin: auto;
  margin-top: ${(props) => props.isNewsletterPage ? "15px" : "60px"};
`

export const CompanyImage = styled.img`
  height: ${(props) => props.isCareerHub ? "30px" : "40px"};
  width: fit-content;
  margin: ${(props) => props.isCareerHub ? "0 40px" : "0 60px"};
  @media screen and (max-width: 780px) {
    height: 30px;
    margin: 0 30px;
  }
`

/* COURSES PAGE STYLES */

export const MarqueeContainerDark = styled.div`
  max-width: 900px;
  padding-bottom: 80px;

  @media screen and (max-width: 1350px) {
    max-width: 750px;
  }

  @media screen and (max-width: 1185px) {
    grid-column: 1/7 !important;
  }

  @media screen and (max-width: 760px) {
    max-width: 100vw !important;;
    grid-column: 1/13 !important;;
  }
`

export const CoursePageMarqueeTitle = styled.div`
  color: white;
  ${({ theme: { typography } }) => typography.desktop.body};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  grid-column: 1/9;
  margin-bottom: 30px;
  margin-top: 10px;

  @media screen and (max-width: 1185px) {
    grid-column: 1/7;
  }

  @media screen and (max-width: 760px) {
    max-width: 100vw;
    grid-column: 1/13;
    ${({ theme: { typography } }) => typography.mobile.body};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  }
`

export const Image = styled.img`
  height: 30px;
  width: fit-content;
  margin: 0 40px;
  filter: brightness(0) invert(1) opacity(0.85);

  @media screen and (max-width: 780px) {
    height: 30px;
    margin: 0 30px;
  }
`

export const Wrapper = styled.div`
  position: relative;
  height: 60px;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 10vw;
    z-index: 2;
    pointer-events: none;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #373f49, transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #373f49, transparent);
  }
`